import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DxButtonComponent, DxLoadPanelModule, DxScrollViewModule } from 'devextreme-angular';
import { ProductionReportViewerModule } from '../../components/production-report-viewer-page/production-report-viewer-page.module';
import { ProductionDashboardsModule } from '../production-dashboards';
import { ReportsViewerComponent } from './reports-viewer.component';
import { ReportDefaultSettingsModalComponent } from './report-default-settings-modal/report-default-settings-modal.component';

/**
 * The shared reports viewer: tiles, the report page and the two dashboards. Apps route to it
 * with `buildReportsViewerRoutes` and describe the viewer through PRODUCTION_DASHBOARD_CONTEXT.
 */
@NgModule({
  declarations: [ReportsViewerComponent],
  imports: [
    CommonModule,
    ProductionDashboardsModule,
    ProductionReportViewerModule,
    DxLoadPanelModule,
    DxScrollViewModule,
    DxButtonComponent,
    ReportDefaultSettingsModalComponent,
  ],
  exports: [ReportsViewerComponent],
})
export class ReportsViewerModule {}
